import { type FC } from "react";
import { StyledRectangleContainer, StyledContainer } from "./styled";

const FiveVerticalCardsBlockPlaceholder: FC = () => {
  return (
    <StyledContainer>
      <Rectangle />
      <Rectangle />
      <Rectangle />
      <Rectangle />
      <Rectangle />
    </StyledContainer>
  );
};

const Rectangle: FC = () => {
  return <StyledRectangleContainer />;
};

export default FiveVerticalCardsBlockPlaceholder;
